import React from 'react';
import { Modal } from 'carbon-components-react';
import {
  HTMLViewer,
  ImageViewer,
  PDFViewer,
  IFrameViewer,
  DWFViewer
} from 'components';

export const PreviewerSuperModal: React.FC<Props | any> = (props: Props) => {
  const {
    showDMFViewer,
    setShowDMFViewer,
    isOpen,
    onClose,
    previewData,
    selectedReferralObj,
    isModal,
    inboundEmailId,
    enquiryId
  } = props;

  const viewerContentHeight = `calc(100vh - 10rem)`;

  return (
    <div className="previewer-super-modal">
      <Modal
        open={isOpen}
        modalHeading={selectedReferralObj?.name}
        onRequestClose={onClose}
        passiveModal
        size="lg"
        className={`super-modal ${isModal ? '' : 'single-modal'}`}
      >
        <div className="super-modal-content">
          <div
            className={`super-modal-content-body ${
              previewData?.type === 'pdf' || previewData?.type === 'image'
                ? 'body-pdf'
                : ''
            }`}
          >
            {previewData?.type === 'webMap' && previewData?.body && (
              <IFrameViewer
                className="get-plans-responses-content-viewer-previewer-webmap"
                source={previewData?.body}
                selectedData={selectedReferralObj}
                title={'Web map'}
              />
            )}
            {previewData?.type === 'html' && previewData?.body && (
              <HTMLViewer
                html={previewData?.body}
                title="Response body"
                isSuperModal={true}
                inboundEmailId={inboundEmailId}
                referralId={selectedReferralObj?.externalId}
                enquiryId={enquiryId}
              />
            )}
            {previewData?.type === 'image' && previewData?.body && (
              <ImageViewer
                fileId={previewData?.id}
                imageSource={previewData?.body}
                imageName={previewData?.name}
                isSuperModal={true}
              />
            )}
            {previewData?.type === 'pdf' && previewData?.body && (
              <PDFViewer
                fileId={previewData?.id}
                fileUrl={previewData?.body}
                fileName={previewData?.name}
                isSuperModal={true}
                viewerContentHeight={viewerContentHeight}
              />
            )}
            {previewData?.type === 'dwf' && previewData?.body && (
              <DWFViewer
                showViewer={showDMFViewer}
                setShowViewer={setShowDMFViewer}
                title={previewData?.name}
                fileId={previewData?.id}
                enquiryId={enquiryId}
                dataBody={previewData?.body}
              />
            )}
            {previewData?.type === 'unknown' && previewData?.body && (
              <div className="get-plans-responses-content-viewer-previewer-unsupported">
                <div>Unsupported file for preview</div>
                <div>File will be downloaded and will begin shortly</div>
              </div>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};

type ownProps = {
  showDMFViewer: boolean;
  setShowDMFViewer: Function;
  isOpen: boolean;
  onClose: any;
  previewData: any;
  selectedReferralObj: any;
  isModal?: boolean;
  inboundEmailId?: number;
  enquiryId?: number;
};

type Props = ownProps;

PreviewerSuperModal.displayName = 'PreviewerSuperModal';

export default React.memo(PreviewerSuperModal);
